<script>import { router } from "@inertiajs/core";
import { onDestroy } from "svelte";
import { usePage } from "../page";
export let data = "";
export let params = {};
export let buffer = 0;
export let as = "div";
export let always = false;
let loaded = false;
let fetching = false;
let el;
let observer = null;
const page = usePage();
$: keys = data ? Array.isArray(data) ? data : [data] : [];
$: loaded = keys.length > 0 && keys.every((key) => $page.props[key] !== void 0);
$: if (el && (!loaded || always)) {
  registerObserver();
}
function registerObserver() {
  observer?.disconnect();
  observer = new IntersectionObserver(
    (entries) => {
      if (!entries[0].isIntersecting) {
        return;
      }
      if (fetching) {
        return;
      }
      if (!always && loaded) {
        return;
      }
      fetching = true;
      const reloadParams = getReloadParams();
      router.reload({
        ...reloadParams,
        onStart: (event) => {
          fetching = true;
          reloadParams.onStart?.(event);
        },
        onFinish: (event) => {
          loaded = true;
          fetching = false;
          reloadParams.onFinish?.(event);
          if (!always) {
            observer?.disconnect();
          }
        }
      });
    },
    {
      rootMargin: `${buffer}px`
    }
  );
  observer.observe(el);
}
onDestroy(() => {
  observer?.disconnect();
});
function getReloadParams() {
  const reloadParams = { ...params };
  if (data !== "") {
    reloadParams.only = Array.isArray(data) ? data : [data];
  }
  return reloadParams;
}
</script>

{#if always || !loaded}
  <svelte:element this={as} bind:this={el} />
{/if}

{#if loaded}
  <slot {fetching} />
{:else if $$slots.fallback}
  <slot name="fallback" />
{/if}
